import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Import images

const BranchSlider = () => {
  const [branchInfo, setBranchInfo] = useState([]);
  // const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state
  const user_id = ACCESS_Log_In_User_Id();
  const { id, flags } = useParams();
  const currentUserId = user_id ? user_id : id;
  const [userData, setUserData] = useState({
          user_id: "",
          role_id: "",
  });

  const fetchUserInfoDetails = async () => {

    axios.get(`${API_BASE_URL}/getpersonalInfoDetails?user_id=${currentUserId}`)
        .then(function (response) {
            console.log(response);
            if (response.data.code == 200) {
                console.log(response.data.data[0]);
                //setpersonalInfoDetails(response.data.data[0]);
                setUserData({
                    role_id: response.data.data[0]["role_id"],
                    user_id: response.data.data[0]["user_id"],
                });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
  };

  const fetchBranches = async () => {
    console.log("user data", userData);
    try {
      const response = await axios.get(`${API_BASE_URL}/getBranchesData`, {
        params: {
          user_id: userData.user_id, // Replace with dynamic user_id
          role_id: userData.role_id, // Replace with dynamic role_id
        },
      });
      setBranchInfo(response.data.data);
      // setProfileImg(response.data.data.profileImg);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };
// console.log("Branch information", branchInfo);
useEffect(() => {
  fetchUserInfoDetails();
}, []);

useEffect(() => {
  if (userData.user_id && userData.role_id) {
    fetchBranches();
  }
}, [userData]);

  return (
    <div className="institute-slider-container event-slider">
      {/* Show loader if data is still being fetched */}
      {loading ? (
        <p>Loading institutes...</p>
      ) : branchInfo.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          }}
        >
          {branchInfo.map((branch, index) => (
          <div class="course-item wow fadeInUp" data-wow-delay=".25s" key={branch.id}>
            <div class="heading_branch">{branch.name}</div>
            <div class="course-content pd_10 video_title">
              <div class="pb-3">
                <div class="common_round float-left"><i class="far fa-phone-volume"></i></div>
                <div class="text ps-5 info_txt">{branch.phone_no}</div>
              </div>
              <div class="pb-3">
                  <div class="common_round float-left"><i class="far fa-envelopes"></i></div>
                  <div class="text ps-5 info_txt"> {branch.email_id}</div>
              </div>
              <div class="pb-2">
                  <div class="common_round float-left"><i class="fa-solid fa-location-dot"></i></div>
                  <div class="text ps-5 info_txt">{branch.address}</div>
              </div>
            </div>
          </div>
          ))}
          </OwlCarousel>
          ) : (
            <p>No branches available.</p>
          )}
    </div>
  );
};

export default BranchSlider;